import { render, staticRenderFns } from "./DeliveryDetails_Items.vue?vue&type=template&id=2180d47a&"
import script from "./DeliveryDetails_Items.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetails_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports